import styled from '@emotion/styled';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';
import React from 'react'
import Chip from '@mui/material/Chip';
import Reviews from './Reviews';
import mainContext from '../../../contexts/mainContext';
import { getBabySitterProfileController } from '../../../Controllers/userManagment/babySitter';
import AvailabilityCalender from '../../Common/AvailabilityCalender';
import CloseIcon from '@mui/icons-material/Close';
import { __snackBarSeverity, __snackBarText, __constants } from '../../../constants';
import avatar from '../EditProfile/avatar.png'
import moment from "moment"
import IdVerification from '../../Common/IdVerification'

const BabySitter = ({ open, setOpen, userId }) => {
    const { setCanvasTitle, setPageload, setSnackBar } = React.useContext(mainContext);

    const [state, setState] = React.useState({
        userInfo: {},
        availableForBabyCare: [],
        interestedForBabyCare: [],
        specialityForBabyCare: [],
        childRangeExperience: [],
        iHaveForBabyCare: [],
        experience: [],
        languages: [],
        lngString: "",
        comfortableChild: 0,
        pic: null,
        rawImage: null
    })

  const [currentMonth, setCurrentMonth] = React.useState(moment().format("YYYY-MM"))

  const getBabySitterProfile = async (month = moment().format("YYYY-MM")) => {
        setPageload(true)
        const res = await getBabySitterProfileController(userId, month)
        if (res.status === 200) {
            let lang = ""
            res?.data?.userInfo?.languages[0]?.map((lng, index) => {
                lang = lang + lng + (index < res?.data?.userInfo?.languages[0].length - 1 ? ", " : "")
            })
            setState({
                ...state,
                ...res.data,
                comfortableChild: res?.data?.userInfo?.comfortableChild[0],
                lngString: lang,
                rawImage: __constants.images + res.data.userInfo?.profilePicture
            })
        } else {
            return callSnackBar(res.message, "error")
        }
        setPageload(false)

    }

    /* Call snackbar */
    const callSnackBar = (msg, type) => {
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
   }

    const handleMonthChange = (newMonth) => {
      setCurrentMonth(newMonth)
      getBabySitterProfile(newMonth)
    }

    React.useEffect(() => {
        if (open) {
            getBabySitterProfile();
        }
        setCanvasTitle("Baby sitter profile");
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <Container>
                <Header>
                    <h4>{state?.userInfo?.firstName} {state?.userInfo?.lastName} profile</h4>
                    <CloseIcon className='pointer' onClick={() => { setOpen(false) }} />
                </Header>

                <Body className='scroll-bar-hidden'>
                   <ProfilePic>
                        <div className="img-container">
                            <img
                                onError={(e) => { setState({ ...state, rawImage: `${__constants.images}default_upscaled.png`}) }}
                                src={state.rawImage}
                            />
                        </div>
                    </ProfilePic>
                    <UserDeatils>
                        <UserAbout>
                            <strong className="title">
                                Onboarding Progress
                            </strong>
                            <div style={{ marginTop: '0.5rem', fontSize: '90%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.isEmailVerify ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.isEmailVerify ? 1 : 0.6 }}>Email Verified</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.isMobileNoVerify ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.isMobileNoVerify ? 1 : 0.6 }}>Mobile Verified</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.isProfileCompleted ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.isProfileCompleted ? 1 : 0.6 }}>Basic Profile Created</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.isJobProfileCompleted ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.isJobProfileCompleted ? 1 : 0.6 }}>Job Profile Completed</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                                    <span style={{ marginRight: '8px' }}>{state?.userInfo?.stripeAccountOnBoard?.completedOn || state?.userInfo?.paypalAccountOnBoard?.completedOn ? '✅' : '❌'}</span>
                                    <span style={{ opacity: state?.userInfo?.stripeAccountOnBoard?.completedOn || state?.userInfo?.paypalAccountOnBoard?.completedOn ? 1 : 0.6 }}>Payment Method Setup</span>
                                </div>
                                <IdVerification
                                    userId={userId}
                                    verification={state?.userInfo?.stripeIdentityVerification}
                                    badgeEnabled={state?.userInfo?.isIdVerifiedBadge}
                                />
                            </div>
                        </UserAbout>
                        <Divider className='divider-gap' />
                        <UserAbout>
                            <strong className="title">
                                About
                            </strong>
                            <p>{state?.userInfo?.aboutMe}</p>
                        </UserAbout>
                        <Divider className='divider-gap' />
                        <Expericence>
                            <strong className="title">
                                Experience
                            </strong>
                            <div>
                                  {state?.userInfo?.experience?.length > 0 &&
                                  state.userInfo.experience[0].from &&
                                  state.userInfo.experience[0].to && (
                                <Chip label={`${state?.userInfo?.experience?.length > 0 && state?.userInfo?.experience[0]?.from} - ${state?.userInfo?.experience?.length && state?.userInfo?.experience[0]?.to} years`} size="small" className="mui-clip" />
                                )}
                                <ul>
                                    {
                                        state?.childRangeExperience?.map((e) => {
                                            return (
                                                <li key={e._id} className={`${!e.isMarked && "inactive"}`}>
                                                    <Icon>
                                                        <img src={__constants.images + e.image} />
                                                    </Icon>
                                                    {e.name}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            <div>
                                   {state?.userInfo?.referrenceDocument?.length > 0 && (
                                <Chip className="mui-clip" label="References" size="small" /> )}
                                <ul>
                                    {state?.userInfo?.referrenceDocument && state?.userInfo?.referrenceDocument[0]?.length > 0 && state?.userInfo?.referrenceDocument[0].map((item) => <li><a className='pointer' href={__constants.images + item.name} target="_blank">View reference</a></li>)}
                                    <li> {state?.userInfo?.referrenceDocument && state?.userInfo?.referrenceDocument[0]?.length === 0 && "Not available"}</li>
                                </ul>
                            </div>
                        </Expericence>
                        <Divider className='divider-gap' />
                        <Expericence>
                            <strong className="title">
                                I have
                            </strong>
                            {state?.iHaveForBabyCare?.length > 0 && (
                              <div style={{ marginTop: '0.5rem', fontSize: '90%', display: 'flex', justifyContent: 'space-between', columnGap: '1rem' }}>
                                <Chip label="Has" size="small" className="mui-clip" />
                                <ul style={{ width: '65%' }}>
                                  {state?.iHaveForBabyCare.map((e) => (
                                    <li key={e._id} className={`${!e.isMarked && "inactive"}`} style={{ margin: '6px 0', display: 'flex', alignItems: 'center' }}>
                                      <Icon>
                                        <img src={__constants.images + e.image} />
                                      </Icon>
                                      {e.name}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                        </Expericence>
                        <Divider className='divider-gap' />
                        <Services>
                            <strong className="title">
                                Services
                            </strong>
                            <div>
                                 {state?.userInfo?.comfortableChild?.length > 0 && (
                                <Chip label={(state?.userInfo?.comfortableChild || 0) + " children at once"} size="small" className="mui-clip" />
                               )}
                                <ul>
                                    {state?.interestedForBabyCare?.map((obj) => <li className={`${!obj.isMarked && "inactive"}`}>
                                        <Icon>
                                            <img src={__constants.images + obj.image} />
                                        </Icon>
                                        {obj.name}</li>)}
                                </ul>
                            </div>
                            <div>
                              {(state?.userInfo?.hourlyRateForOneOrTwoChild?.length > 0 ||
                                state?.userInfo?.hourlyRateForThreeChild?.length > 0) && (
                                <>
                                  <Chip label="Hourly rate" size="small" className="mui-clip" />
                                  <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                                    {state?.userInfo?.hourlyRateForOneOrTwoChild?.length > 0 && (
                                      <li
                                        style={{
                                          width: '100%',
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                        }}
                                      >
                                        Up to 2 children
                                        <Chip
                                          label={
                                            state.userInfo.hourlyRateForOneOrTwoChild[0] != null
                                              ? `${state.userInfo.hourlyRateForOneOrTwoChild[0]} dollar/h`
                                              : '---'
                                          }
                                          size="small"
                                          className="mui-clip"
                                        />
                                      </li>
                                    )}

                                    {state?.userInfo?.hourlyRateForThreeChild?.length > 0 && (
                                      <li
                                        style={{
                                          width: '100%',
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                        }}
                                      >
                                        3 children
                                        <Chip
                                          label={
                                            state.userInfo.hourlyRateForThreeChild[0] != null
                                              ? `${state.userInfo.hourlyRateForThreeChild[0]} dollar/h`
                                              : '---'
                                          }
                                          size="small"
                                          className="mui-clip"
                                        />
                                      </li>
                                    )}
                                  </ul>
                                </>
                              )}
                            </div>
                            <div>
                              {state?.userInfo?.overnightRate?.[0] != null &&
                                state.userInfo.overnightRate[0] !== false && (
                                  <>
                                    <Chip label="Overnight rate" size="small" className="mui-clip" />
                                    <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                                      <li
                                        style={{
                                          width: '100%',
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                        }}
                                      >
                                        Up to 2 children
                                        <Chip
                                          label={`${state.userInfo.overnightRate[0]} dollar/h`}
                                          size="small"
                                          className="mui-clip"
                                        />
                                      </li>
                                    </ul>
                                  </>
                              )}
                            </div>
                        </Services>
                        <Divider className='divider-gap' />
                        <Skills>
                            <strong className="title">
                                Skills
                            </strong>
                        {/* Speaks Section */}
                        {state?.userInfo?.languages?.[0]?.length > 0 && (
                          <div>
                            <Chip label="Speaks" size="small" className="mui-clip" />
                            <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                              {state.userInfo.languages[0].map((e, index) => (
                                <li style={{ display: 'inline-block' }} key={index}>
                                  {e}
                                  {index < state.userInfo.languages[0].length - 1 ? ', ' : ''}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        
                        {/* Specialises In Section */}
                        {state?.specialityForBabyCare?.some((e) => e.isMarked) && (
                          <div>
                            <Chip label="Specialises in" size="small" className="mui-clip" />
                            <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                              {state.specialityForBabyCare.map((e, index) =>
                                e.isMarked ? (
                                  <li key={index}>
                                    <Icon>
                                      <img src={__constants.images + e.image} alt={e.name} />
                                    </Icon>
                                    {e.name}
                                  </li>
                                ) : null
                              )}
                            </ul>
                          </div>
                        )}
                        </Skills>
                        <Divider className='divider-gap' />
                        <Availability>
                            <strong className="title">
                                Availability
                            </strong>
                            {state?.availableForBabyCare?.some((e) => e.isMarked) && (
                              <div>
                                <Chip label="Available for" size="small" className="mui-clip" />
                                <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
                                  {state.availableForBabyCare.map((e, index) =>
                                    e.isMarked ? (
                                      <li key={index}>
                                        <Icon>
                                          <img src={__constants.images + e.image} alt={e.name} />
                                        </Icon>
                                        {e.name}
                                      </li>
                                    ) : null
                                  )}
                                </ul>
                              </div>
                            )}
                        </Availability>

                        <AvailabilityCalender availabilityTime={state?.userInfo?.availabilityTime?.length > 0 ? state?.userInfo?.availabilityTime[0] : null}onMonthChange={handleMonthChange} />

                        <Divider className='divider-gap' />
                        <Reviews reviewDetails={state?.userInfo?.reviewDetails} review={state?.userInfo?.review} userId={userId} />
                    </UserDeatils>
                </Body>
            </Container>
        </>
    )
}

const Container = styled("div")`
    height: 100%;
    width: 30vw;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    overflow: hidden;
    min-width:300px;
    .title{
        color: var(--nona-theme-color);
        font-size: 90%;
    }
    .divider-gap{
        margin: 0.5rem 0;
    }
    .button{
      border-radius: 10px;
      width: 100%;
      text-transform: unset;
      display: flex;
      font-family: 'semi-bold'
    }
    .profile_img_div{
        height: 30%;
    }
    .image_handler{
        height: 200px;
        width: 100%;
        object-fit: cover;
    }
    .inactive{
        opacity:0.5
    }
`;

const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-weight: 900;
        font-size: 120%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
    margin-top: 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;

const ProfilePic = styled("div")`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    
    .img-container {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        overflow: hidden;
        border: 3px solid #e2a988;
    }
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
`;

const Icon = styled("div")`
display:inline-block;
margin-right:10px;
img{
    max-width:20px;
}
`

const UserDeatils = styled("div")`
    width: 95%;
    margin: auto;
`;

const UserAbout = styled("div")`
    p{
        margin-top: 0.2rem;
        font-size: 80%;
    }
`;

const Expericence = styled("div")`
    &>div{
        margin-top: 0.5rem;
        font-size: 90%;
        display: flex;
        justify-content: space-between;
        ul{
            width:65%;
        }
        li{
            margin:6px 0;
            display:flex;
            align-items:center;
        }
        column-gap: 1rem;
    }
`;

const Services = styled("div")`
    &>div{
        margin-top: 0.5rem;
        font-size: 90%;
        display: flex;
        justify-content: space-between;
        column-gap: 1rem;
        ul{
            width:65%;
        }
        li{
            margin-top: 0.5rem;
            display: flex;
            align-items: center;
            margin:6px 0;
        }
    }
`;

const Skills = styled("div")`
     &>div{
        margin-top: 0.5rem;
        font-size: 90%;
        display: flex;
        column-gap: 1rem;
        justify-content: space-between;
        ul{
            width:65%;
        }
        li{
            margin:6px 0;
        }
    }
`;

const Availability = styled("div")`
    &>div{
        margin-top: 0.5rem;
        font-size: 90%;
        display: flex;
        justify-content: space-between;
        ul{
            width:65%;
        }    
        li{
            margin:8px 0;
        }
        column-gap: 1rem;
    }
`;

const Footer = styled("div")`
    margin: auto;
    margin-top: 5%;
    padding-bottom: 5%;
    width: 95%;
    display: flex;
    justify-content: center;
    column-gap: 1rem;
`;

export default BabySitter
